import { render, staticRenderFns } from "./LoginBoxZx.vue?vue&type=template&id=5cea491e&scoped=true&"
import script from "./LoginBoxZx.vue?vue&type=script&lang=js&"
export * from "./LoginBoxZx.vue?vue&type=script&lang=js&"
import style0 from "./LoginBoxZx.vue?vue&type=style&index=0&id=5cea491e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea491e",
  null
  
)

export default component.exports